// extracted by mini-css-extract-plugin
module.exports = {"content":"index_content__o2UM9","h2":"index_h2__iytAF","container":"index_container__F5mtF","bigImgItem":"index_bigImgItem__lcrd2","descList":"index_descList__V2sEL"};